import { createSelector } from 'reselect'
import productTypes from 'helpers/enums/productTypes'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'

const getLibraries = state => state.libraries
const getUserIsLogged = state => state.user.logged
const getUserData = state => state.user.data

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.PAYWALLS_PROJECT,
])

const cart_download_product_selector = createSelector(
	[ getLibraries, getUserIsLogged, getUserData, featureFlagsSelector ],
	(library, userIsLogged, userData, featureFlags) => ({
		libraryUID: library.current.libraryUID,
		userIsLogged,
		intercomIO: userData.intercomIO,
		maxStorage: userData.maxStorage,
		shouldOfferUpgrade: userData.productId === productTypes.SILVER ||
			featureFlags[featureFlagsTypes.PAYWALLS_PROJECT],
		shouldShowNewTitle: featureFlags[featureFlagsTypes.PAYWALLS_PROJECT],
	})
)

export default cart_download_product_selector
